import React from 'react'

const Navbar = () => {
  return (
    <div className="nav">
    <nav className='navs'>
      <div></div>
      <div>Pro Teach</div>
      <div></div>
    </nav>
    </div>
  )
}

export default Navbar